import api from './api';

export const getSavingsMonths = () => api.get('/savings/months');
export const getSavingsForMonth = (month) => api.get(`/savings/${month}`);
export const getSavingsTrends = () => api.get('/savings/trends');
